/**
 * tdesign v0.46.3
 * (c) 2022 tdesign
 * @license MIT
 */

var props = {
  activable: Boolean,
  actived: {
    type: Array
  },
  defaultActived: {
    type: Array
  },
  activeMultiple: Boolean,
  checkable: Boolean,
  checkProps: {
    type: Object
  },
  checkStrictly: Boolean,
  data: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  disableCheck: {
    type: [Boolean, Function],
    "default": false
  },
  disabled: Boolean,
  empty: {
    type: [String, Function],
    "default": ""
  },
  expandAll: Boolean,
  expanded: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  defaultExpanded: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  expandLevel: {
    type: Number,
    "default": 0
  },
  expandMutex: Boolean,
  expandOnClickNode: Boolean,
  expandParent: Boolean,
  filter: {
    type: Function
  },
  hover: Boolean,
  icon: {
    type: [Boolean, Function],
    "default": true
  },
  keys: {
    type: Object
  },
  label: {
    type: [String, Boolean, Function],
    "default": true
  },
  lazy: {
    type: Boolean,
    "default": true
  },
  line: {
    type: [Boolean, Function],
    "default": false
  },
  load: {
    type: Function
  },
  operations: {
    type: Function
  },
  transition: {
    type: Boolean,
    "default": true
  },
  value: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  defaultValue: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  valueMode: {
    type: String,
    "default": "onlyLeaf",
    validator: function validator(val) {
      return ["onlyLeaf", "parentFirst", "all"].includes(val);
    }
  },
  onActive: Function,
  onChange: Function,
  onClick: Function,
  onExpand: Function,
  onLoad: Function
};

export { props as default };
//# sourceMappingURL=props.js.map
